














































































































import { Component, Watch, Vue } from 'vue-property-decorator'
/* component */
import CommonHeader from '@/app/components/Common/Header.vue'
import Loading from '@/app/components/Common/Loading.vue'
import ErrorModal from '@/app/components/Common/ErrorModal.vue'
import AreaSearch from '@/app/components/Area/AreaSearch.vue'
import AreaList from '@/app/components/Area/AreaList.vue'
/* api */
import AreaListApi from '@/app/model/api/areaListApi'
/* module */
import Session from '@/app/module/session'
import CommonClass from '@/app/module/common'
import { routerPath, userType, errorFlag } from '@/app/model/store/domain/const'

@Component({
  components: {
    CommonHeader,
    Loading,
    ErrorModal,
    AreaSearch,
    AreaList
  }
})
export default class AreaMaster extends Vue {
  /* データ */
  private areaData: any = {}
  private sort: string = ''
  private totalCount: number = 0
  private alertText: string = ''
  private alertMessage: string = this.$store.state.alertState.message
  /* 表示非表示 */
  private notDataMessage: boolean = false
  private showServerErrorModal: boolean = false
  private showLoading: boolean = true

  created () {
    this.getAreaList('')
  }

  /* 初期表示&検索&ソート */
  private getAreaList (sortName: string) {
    (async () => {
      this.showLoading = true

      /* state保持 */
      if (sortName !== '') {
        if (this.$store.state.areaState.sortAsc) {
          this.$store.commit('areaState/setSortAsc', false)
        } else {
          this.$store.commit('areaState/setSortAsc', true)
        }
      }
      if (sortName !== this.$store.state.areaState.sortName && sortName !== '') {
        this.$store.commit('areaState/setSortName', sortName)
        this.$store.commit('areaState/setSortAsc', true)
      }

      if (this.$store.state.areaState.sortAsc) {
        this.sort = 'asc'
      } else {
        this.sort = 'desc'
      }

      const data : any = {
        sortName: this.$store.state.areaState.sortName,
        sort: this.sort,
        text: this.$store.state.areaState.searchText
      }

      const result = await AreaListApi.getAreaList(data)

      if (result.isOk()) {
        this.updateList(result.getPayload().areas)
        this.areaData = result.getPayload().areas
        this.totalCount = result.getPayload().total_area
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
      this.showLoading = false
    })()
  }

  private updateList (val: any) {
    this.$store.commit('areaState/setAreaList', val)
    this.areaData = this.$store.state.areaState.areaData

    if (this.areaData.length === 0) {
      this.notDataMessage = true
    } else {
      this.notDataMessage = false
    }
  }

  private logout () {
    CommonClass.doLogout()
  }
}
